// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"SeasonsList_pageHeader__9iIWU","yearTabPill":"SeasonsList_yearTabPill__2l8qC"};